module.exports = __webpack_public_path__ + "img/hp-mp9-red.864266c2.png";